/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RoleBase {
    getFixupPrototypeFunction() { return RoleBase.fixupPrototype; }

    static newInstance(model: Partial<RoleBase>): RoleBase {
        let obj = Object.assign(new RoleBase(), model);
        RoleBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RoleBase>): RoleBase {
        if (!model) return null;
        return RoleBase.newInstance(<RoleBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RoleBase) {
        if (!obj) return;

        models.RoleBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RoleBase): boolean {
        Object.setPrototypeOf(obj, RoleBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.metadata) {
            for (let val of this.metadata) {
                models.KeyValuePair.fixupPrototype(val);
            }
        }
    }

    /**
     * Name of the role. Unique within a tenant
     */
    name: string;

    /**
     * Description of the role
     */
    description: string;

    /**
     * List of tag key/value pairs
     */
    metadata: Array<models.KeyValuePair>;

    /**
     * Cloud providers the role applies to
     */
    cloud_services: Array<models.CloudServiceName>;

    /**
     * Integrated tools the role applies to
     */
    integrated_tools: Array<models.IntegratedToolName>;

    /**
     * Resource element IDs the role is scoped to
     */
    resource_elements: Array<string>;

    /**
     * Service account IDs the role is scoped to
     */
    service_accounts: Array<string>;

    /**
     * SaaS services the role applies to
     */
    saas_services: Array<models.SaasServiceName>;

}
